import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["children"];
import _Object$values from "@babel/runtime-corejs2/core-js/object/values";
import * as React from 'react';

/**
 * React context creation helper.
 * Helps properly typing a context without passing dumb default values while
 * still ensuring safety.
 * Reduce boilerplate.
 * Add memoization improvements.
 * Add debugging markers.
 */

export function createContext(rootName, defaultContext) {
  var Context = /*#__PURE__*/React.createContext(defaultContext);
  function Provider(props) {
    var children = props.children,
      context = _objectWithoutProperties(props, _excluded);

    // Only re-memoize when prop values change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var value = React.useMemo(function () {
      return context;
    }, _Object$values(context));
    return /*#__PURE__*/React.createElement(Context.Provider, {
      value: value
    }, children);
  }
  function useContext(consumerName) {
    var context = React.useContext(Context);
    if (context) {
      return context;
    }
    if (defaultContext !== undefined) {
      return defaultContext;
    }

    // if a defaultContext wasn't specified, it's a required context.
    throw new Error("`".concat(consumerName, "` must be used within `").concat(rootName, "`"));
  }
  Provider.displayName = "".concat(rootName, "Provider");
  return [Provider, useContext];
}